var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"directory-tree"},[(_vm.root)?_c('media-library-tree-item',{attrs:{"directory":_vm.root}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }